import { useIntl } from '@edx/frontend-platform/i18n';
import StaticPageLayout from './StaticPageLayout';
import { getHelpPageContent } from './content';

const HelpPage = () => {
  const intl = useIntl();

  return <StaticPageLayout {...getHelpPageContent(intl)} />;
};

export default HelpPage;
